module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_design/pastel-2baab8db586e9e0faec695d850cbf4c8.png";